/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Container from '../../atoms/Container/Container';
import CustomEmblaCarousel from '../../organisms/CustomEmblaCarousel';
import Style from './VejamTambemAmpless.css';

function VejamTambemAmpless({ importPrefix }) {
  return (
    <section id="sec-veja-tambem">
      <Container id="vejaTambem">
        <h2>Veja também</h2>
        <div className="container-veja">
          <CustomEmblaCarousel fillHeight enablePrevArrow>
            {({ className }) => (
              <>
                <a
                  className={`slide ${className}`}
                  href="credenciados.html"
                  id="veja-tambem-busca-na-revenda-e-lojas-credenciadas-acessar"
                >
                  <h3>
                    Busca na revenda e <br />
                    Lojas Credenciadas
                  </h3>
                  <img
                    src={`${importPrefix}static/amp/home/revenda.png`}
                    alt="Homem apertando as mãos para fechar negócio de revenda"
                    height="255"
                    width="269"
                  />
                  <u>Acessar</u>
                </a>
                <a
                  className={`slide ${className}`}
                  href="cdc-protegido.html"
                  id="veja-tambem-seguro-santander-cdc-protegido-acessar"
                >
                  <h3>
                    Seguro Santander <br />
                    CDC Protegido
                  </h3>
                  <img
                    src={`${importPrefix}static/amp/home/CDC.png`}
                    alt="Casal avaliando porposta"
                    height="255"
                    width="269"
                  />
                  <u>Acessar</u>
                </a>
                <a
                  className={`slide ${className}`}
                  href="leilao-de-veiculos.html"
                  id="veja-tambem-leilao-de-veiculos-acessar"
                >
                  <h3>Leilão de Veículos</h3>
                  <img
                    src={`${importPrefix}static/amp/home/leilao_veiculos.png`}
                    alt="Carros para vender em leilão"
                    height="255"
                    width="269"
                  />
                  <u>Acessar</u>
                </a>
                <a
                  className={`slide ${className}`}
                  href="https://www.webmotors.com.br/wm1/dinheiro-e-economia/passo-a-passo-comprar-veiculo-pcd?ori=SF&int_source=veja-pessoas"
                  target="_blank"
                  rel="noopener"
                  id="veja-tambem-pessoas-com-necessidades-especiais-acessar"
                >
                  <h3>
                    Pessoas com <br />
                    necessidades
                    <br /> especiais
                  </h3>
                  <img
                    src={`${importPrefix}static/amp/home/pessoas_especiais.png`}
                    alt="braço apoiado em cadeira de rodas"
                    height="255"
                    width="269"
                  />
                  <u>Acessar</u>
                </a>
              </>
            )}
          </CustomEmblaCarousel>
        </div>
      </Container>
      <style jsx>{Style}</style>
    </section>
  );
}

VejamTambemAmpless.defaultProps = {
  importPrefix: '',
};

export default VejamTambemAmpless;
